var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCmi5 } from "../cmi5Api/cmi5";
import { SuspendDataStatement } from "./SuspendDataStatement";
import { CMI5 } from "@/cmi5/cmi5Api/cmi5ModelIds";
export function sendSuspendDataStatement(suspendData) {
    return __awaiter(this, void 0, void 0, function* () {
        const launchMode = getCmi5().getLaunchMode();
        if (launchMode !== CMI5.LAUNCH_MODE.BROWSE) {
            yield SuspendDataStatement.set(suspendData);
        }
    });
}
